import { AsyncPipe, NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  ViewContainerRef,
  ViewRef,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { Router, RouterLink } from '@angular/router';
import { ofType } from '@ngrx/effects';
import { ActionsSubject, select, Store } from '@ngrx/store';
import { AddToCartComponent } from '@spartacus/cart/base/components/add-to-cart';
import { ActiveCartService, CartActions, MULTI_CART_FEATURE, StateWithMultiCart } from '@spartacus/cart/base/core';
import { ActiveCartFacade, MultiCartFacade, OrderEntry } from '@spartacus/cart/base/root';
import {
  CmsAddToCartComponent,
  CmsService,
  EventService,
  GlobalMessageService,
  GlobalMessageType,
  Page,
  PageType,
  Product,
  ProductService,
  TranslatePipe,
  UrlPipe,
  UserIdService,
} from '@spartacus/core';
import {
  BREAKPOINT,
  BreakpointService,
  CmsComponentData,
  CurrentProductService,
  LaunchDialogService,
} from '@spartacus/storefront';
import { escape } from 'lodash';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Observable, Subscription } from 'rxjs';
import { concatMap, distinctUntilChanged, filter, map, take } from 'rxjs/operators';
import { CUSTOM_LAUNCH_CALLER } from 'src/app/dialog/custom-launch-dialog-config';
import { ShimanoProduct } from 'src/app/model/product.model';
import { BaseSiteConfigService } from 'src/app/service/base-site/base-site-config.service';
import { ComponentService } from 'src/app/service/component.service';
import { ShimanoCountryService } from 'src/app/service/country/shimano-country.service';
import {
  GoogleTagManagerEvent,
  GoogleTagManagerService,
} from 'src/app/service/googletagmanager/google-tag-manager.service';
import { ShimanoLanguageService } from 'src/app/service/language/shimano-language.service';
import { StandardModalService } from 'src/app/service/modal/standard-modal.service';
import { StorageService } from 'src/app/service/storage/storage.service';
import { CurrentBusinessType } from 'src/app/utility/current-businesstype';
import { CartExtendService } from '../../../../service/cart/cart-extend.service';
import { OrderHistoryService } from '../../../../service/orders/order-history.service';
import { ItemCounterComponent } from '../item-counter/item-counter.component';
import { OrderFormDetails } from '../order-form/order-form.component';

interface ProductExtend extends ShimanoProduct {
  showOrderFormButton?: boolean;
  minOrderQuantity?: number;
}

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'cx-add-to-cart',
  templateUrl: './add-to-cart.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AsyncPipe],
  imports: [ItemCounterComponent, MatTooltip, NgClass, MatIcon, RouterLink, AsyncPipe, UrlPipe, TranslatePipe],
})
export class ShimanoAddToCartComponent extends AddToCartComponent implements OnInit, OnDestroy {
  @Input() productCode: string;
  @Input() showQuantity = true;
  @Input() showOrderFormLink = true;
  @Input() isDisabled = false;
  @Input() orderFormDetails: any;

  @Input() product: ShimanoProduct;
  @Input() pageType: string = 'PDP';
  baseProduct$: Observable<Product>;
  pdpDealerPrice: number;
  hasPDPDealerPrice = true;

  maxQuantity: number;
  minOrderQuantity = 1;

  hasStock = false;
  quantity = 1;
  increment = false;
  cartEntry$: Observable<OrderEntry>;

  subscription: Subscription;

  addToCartForm = new FormGroup({
    quantity: new FormControl(1),
  });

  pos: any;
  isMobile = false;
  isMobileSize: boolean;
  isMobileLandscape = false;
  isTablet = false;
  csDesktopWidth = this.breakpointService.getSize(BREAKPOINT.lg);
  csTabletWidth = this.breakpointService.getSize(BREAKPOINT.sm);
  cart: any;
  addToCartInprogress = false;
  showBackorderCartModal = false;
  addToCartSubscription$: Subscription;
  loadAddToCartSubscription$: Subscription;
  pdpDealerPriceSubscription$: Subscription;
  orderFormGtmDataLayerSubscription$: Subscription;
  breakpointSubscription$: Subscription;
  gstLabelsSubscription$: Subscription;
  orderFormGtmDataLayer: any;
  cartAddEntrySuccessSubscription$: Subscription;
  addToCartEntriesProductCodes: string[] = [];
  quantityAdded: number;
  isLoadDisabled = false;
  hasCartAddEntrySuccess = false;
  cartAddEntryFail = false;
  updatedQuantityAdded: number;
  updatedOrderFormDetails: OrderFormDetails[] = [];
  activeLanguage = this.pipeAsync.transform(this.activeLanguage$);
  businessType: string = this.currentBusinesstype.getBusinessType();
  activeCountry$: Observable<string> = this.countryService.getActive();
  categories: any = {};
  currentCountry = this.pipeAsync.transform(this.activeCountry$);
  affiliation = `/${this.businessType}/${this.currentCountry}/${this.activeLanguage}`;
  orderFormItems: any = [];
  orderFormTotalPriceSubscription$: Subscription;
  orderFormTotalPrice = 0;
  discontinuedSubscription$: Subscription;
  isDiscontinued: boolean;
  userCurrent$: Observable<string> = this.userIdService.getUserId();
  userBrowser = this.deviceDetectorService.browser;
  closeModalSubscription$: Subscription;

  @HostBinding('class.float') float: boolean;
  @HostBinding('class.gst-labels-on') gstLabelsOn: boolean;
  @HostBinding('class.pl') activeLanguagePL: boolean;
  @HostBinding('class.no-sv-fi') activeLanguageSNC: boolean;
  backOrderModalSubscription: Subscription;
  isBackOrderPopupEnabled: boolean = false;
  private bodyArray: any[];
  protected readonly escape = escape;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.isMobile = window.innerWidth < this.csTabletWidth;
    this.isTablet = window.innerWidth < this.csDesktopWidth && window.innerWidth >= this.csTabletWidth;
    this.isMobileLandscape = window.innerWidth > 640 && window.innerWidth < 768;

    let heightCut = 360;
    if (this.isMobile) {
      heightCut = 357 - 68;
    }
    if (this.isMobileLandscape) {
      heightCut = 400 + 357 - 68;
    }

    this.pos = this.el.nativeElement.getBoundingClientRect().top + heightCut;

    if (this.pos && this.pos > 300) {
      this.float = window.scrollY > this.pos;

      this.activeLanguagePL = this.pipeAsync.transform(this.activeLanguage$) === 'pl';
      this.activeLanguageSNC =
        this.pipeAsync.transform(this.activeLanguage$) === 'no' ||
        this.pipeAsync.transform(this.activeLanguage$) === 'sv' ||
        this.pipeAsync.transform(this.activeLanguage$) === 'fi';
    }
    this.setProductPricingFloatHeight();
    this.cd.markForCheck();
  }

  constructor(
    private backorderCartService: CartExtendService,
    private multiCartFacade: MultiCartFacade,
    protected cartService: ActiveCartService,
    protected currentProductService: CurrentProductService,
    protected productService: ProductService,
    protected router: Router,
    private messageService: GlobalMessageService,
    private breakpointService: BreakpointService,
    private componentService: ComponentService,
    private store: Store<StateWithMultiCart>,
    private gtmService: GoogleTagManagerService,
    private actionsSubject: ActionsSubject,
    private cms: CmsService,
    private languageService: ShimanoLanguageService,
    private pipeAsync: AsyncPipe,
    private currentBusinesstype: CurrentBusinessType,
    private countryService: ShimanoCountryService,
    private orderHistoryService: OrderHistoryService,
    protected launchDialogService: LaunchDialogService,
    protected cd: ChangeDetectorRef,
    protected activeCartFacade: ActiveCartFacade,
    public deviceDetectorService: DeviceDetectorService,
    private baseSiteConfigService: BaseSiteConfigService,
    private userIdService: UserIdService,
    protected component: CmsComponentData<CmsAddToCartComponent>,
    public eventService: EventService,
    protected modalService: StandardModalService,
    private storageService: StorageService,
    protected el: ElementRef,
    protected vcr: ViewContainerRef
  ) {
    super(currentProductService, cd, activeCartFacade, component, eventService);
  }

  ngOnInit() {
    this.isBackOrderModalEnabled();
    const elAddToCart = document.querySelector('cx-add-to-cart');
    if (this.businessType === 'fish') {
      elAddToCart?.classList?.add('fish-add-to-cart-btn');
      elAddToCart?.classList?.add(this.currentCountry); // add country class for PDP price float styling
    }
    if (this.userBrowser.toLowerCase() === 'firefox') {
      elAddToCart?.classList?.add('mozilla-add-to-cart-btn');
    }

    if (this.product) {
      this.productCode = this.product.code;
      this.cartEntry$ = this.cartService.getEntry(this.productCode);
      this.setStockInfo(this.product);
      this.cd.markForCheck();
    } else if (this.productCode) {
      this.cartEntry$ = this.cartService.getEntry(this.productCode);
      // force hasStock and quantity for the time being, as we do not have more info:
      this.quantity = 1;
      this.hasStock = true;
      this.cd.markForCheck();
    } else {
      this.subscription = this.currentProductService
        .getProduct()
        .pipe(filter(Boolean))
        .subscribe((product: any) => {
          this.productCode = product.code;
          this.setStockInfo(product);
          this.cartEntry$ = this.cartService.getEntry(this.productCode);
          this.cd.markForCheck();

          this.baseProduct$ = this.productService.get(product.baseProduct);
          this.product = product;
          this.showOrderFormLink = product.showOrderFormButton;
          if (product.minOrderQuantity) {
            this.minOrderQuantity = product.minOrderQuantity;
            this.addToCartForm = new FormGroup({
              quantity: new FormControl(product.minOrderQuantity),
            });
          } else {
            this.minOrderQuantity = 1;
            this.addToCartForm = new FormGroup({
              quantity: new FormControl(this.quantity),
            });
          }
        });
    }

    this.orderFormTotalPriceSubscription$ = this.componentService.orderFormTotalPrice$.subscribe(
      (orderFormTotalPrice) => {
        this.orderFormTotalPrice = orderFormTotalPrice;
        this.cd.detectChanges();
      }
    );

    this.addToCartSubscription$ = this.componentService.isAddToCartDisabled$.subscribe((data) => {
      this.isDisabled = data;
      this.cd.detectChanges();
    });

    this.loadAddToCartSubscription$ = this.componentService.isLoadAddToCartDisabled$.subscribe((data) => {
      this.isLoadDisabled = data;
      this.cd.detectChanges();
    });

    this.discontinuedSubscription$ = this.componentService.isDiscontinued$.subscribe((data) => {
      this.isDiscontinued = data;
      this.cd.detectChanges();
    });

    this.pdpDealerPriceSubscription$ = this.componentService.pdpDealerPrice$.subscribe((pdpDealerPrice) => {
      if (pdpDealerPrice > 0) {
        this.hasPDPDealerPrice = true;
      } else {
        this.hasPDPDealerPrice = false;
      }
      this.pdpDealerPrice = +pdpDealerPrice;
      if (!(this.cd as ViewRef).destroyed) {
        this.cd.detectChanges();
      }
    });

    this.orderFormGtmDataLayerSubscription$ = this.componentService.orderFormGtmDataLayer$.subscribe(
      (orderFormGtmDataLayer) => {
        this.orderFormGtmDataLayer = orderFormGtmDataLayer;
        this.cd.detectChanges();
      }
    );

    this.cartAddEntrySuccessSubscription$ = this.actionsSubject
      .pipe(ofType(CartActions.CART_ADD_ENTRY_SUCCESS, CartActions.CART_ADD_ENTRY_FAIL))
      .pipe(
        map((cartAddEntryStatus: any) => {
          if (cartAddEntryStatus.type === CartActions.CART_ADD_ENTRY_SUCCESS) {
            this.quantityAdded = cartAddEntryStatus.payload.quantityAdded;
            this.hasCartAddEntrySuccess = true;
          } else {
            this.quantityAdded = 0;
            this.cartAddEntryFail = true;
          }
          return cartAddEntryStatus;
        }),
        concatMap(() => this.cartService.isStable().pipe(distinctUntilChanged()))
      )
      .subscribe((isCartLoaded) => {
        if (isCartLoaded) {
          this.addToCartInprogress = false;
          this.componentService.setMiniCartLoading(false);
          this.cd.detectChanges();
          if (this.hasCartAddEntrySuccess && typeof this.orderFormDetails !== 'undefined') {
            this.showGlobalMessage('cart.orderForm.addToCartSuccess', GlobalMessageType.MSG_TYPE_CONFIRMATION);

            this.hasCartAddEntrySuccess = false;
          } else if (this.hasCartAddEntrySuccess) {
            this.updateLoaderCTA(this.cart);
            this.hasCartAddEntrySuccess = false;
          }
          if (!this.orderFormDetails) {
            if (this.quantityAdded) {
              this.gtmAddToCart(this.product, this.quantityAdded);
            } else if (this.updatedQuantityAdded > 0) {
              this.gtmAddToCart(this.product, this.updatedQuantityAdded);
            }
          } else {
            this.gtmAddToCart(this.product, null, this.orderFormGtmDataLayer);
          }
        } else {
          if (!this.showBackorderCartModal) {
            this.addToCartInprogress = true;
            this.componentService.setMiniCartLoading(true);
          }
        }
        this.cd.detectChanges();
      });

    this.breakpointSubscription$ = this.breakpointService.breakpoint$.subscribe((breakpoint) => {
      this.isMobileSize = breakpoint === BREAKPOINT.xs;
      this.setProductPricingFloatHeight();
    });

    this.gstLabelsSubscription$ = this.componentService.gstLabelsOn$.subscribe((gstLabelsOn) => {
      this.gstLabelsOn = gstLabelsOn;
      this.cd.detectChanges();
    });
  }

  protected setStockInfo(product: Product): void {
    this.quantity = 1;
    this.hasStock = product.stock && product.stock.stockLevelStatus !== 'outOfStock';
    if (this.hasStock && product.stock.stockLevel) {
      this.maxQuantity = product.stock.stockLevel;
    }
  }

  updateCount(value: number): void {
    this.quantity = value;
  }

  numberOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  addToCart() {
    this.componentService.setMiniCartLoading(true);
    this.cd.detectChanges();
    const quantity = this.addToCartForm.get('quantity').value;
    if (!this.productCode || quantity <= 0) {
      return;
    }
    this.cartService
      .getEntry(this.productCode)
      .pipe((map) => map)
      .subscribe({
        next: (entry) => {
          if (entry) {
            this.increment = true;
            if (entry.product.stock.stockLevel < entry.quantity + quantity) {
              this.updatedQuantityAdded = entry.product.stock.stockLevel - entry.quantity;
            }
          }
          this.cartService.addEntry(this.productCode, quantity);
          this.increment = false;
          this.cart = this.store.pipe(select(MULTI_CART_FEATURE));
        },
        error: (err) => {
          this.addToCartInprogress = false;
          this.componentService.setMiniCartLoading(false);
          this.cd.detectChanges();
        },
      })
      .unsubscribe();
  }

  updateLoaderCTA(cart: any) {
    if (cart) {
      cart.pipe(take(1)).subscribe(
        (cart: any) => {
          if (
            !cart.carts.entities[cart.index.Active].loading &&
            !cart.carts.entities[cart.index.Active].error &&
            cart.carts.entities[cart.index.Active].success
          ) {
            this.componentService.setMiniCartLoading(false);
            this.cd.detectChanges();
            //both PDP and EV
            if (this.pageType === 'PDP') {
              this.showGlobalMessage(
                'cart.addToCartSuccess',
                GlobalMessageType.MSG_TYPE_CONFIRMATION,
                this.productCode
              );
            }
            this.addToCartInprogress = false;
            this.cd.detectChanges();
          }
          if (
            !cart.carts.entities[cart.index.Active].loading &&
            cart.carts.entities[cart.index.Active].error &&
            !cart.carts.entities[cart.index.Active].success
          ) {
            this.addToCartInprogress = false;
            this.componentService.setMiniCartLoading(false);
            this.cd.detectChanges();
          }
        },
        (error: any) => {
          this.addToCartInprogress = false;
          this.componentService.setMiniCartLoading(false);
          this.cd.detectChanges();
        }
      );
    }
  }

  async addToCartOrderForm(orderFormDetails: OrderFormDetails[]) {
    this.addToCartInprogress = true;
    this.componentService.setMiniCartLoading(true);
    orderFormDetails.forEach(async (orderFormDetail) => {
      await this.cartService
        .getEntry(orderFormDetail.productCode)
        .subscribe((entry) => {
          if (entry) {
            this.increment = true;
            if (entry.product.stock.stockLevel < entry.quantity + orderFormDetail.quantity) {
              const quantityAdded = entry.product.stock.stockLevel - entry.quantity;
              this.updatedOrderFormDetails.push({ productCode: orderFormDetail.productCode, quantity: quantityAdded });
            }
          }
          this.cartService.addEntry(orderFormDetail.productCode, orderFormDetail.quantity);
          this.increment = false;
        })
        .unsubscribe();
    });
  }

  gtmAddToCart(product: any, quantity: number, orderFormProductsDetails?: any[]) {
    this.orderFormItems = [];

    if (this.cartAddEntryFail && this.updatedOrderFormDetails) {
      this.updatedOrderFormDetails.forEach((updatedOrderFormDetail) => {
        orderFormProductsDetails.find((d) => d.id === updatedOrderFormDetail.productCode).quantity =
          updatedOrderFormDetail.quantity;
      });
    }
    this.categories = {};
    product.categories.forEach((cat: any, i: any) => {
      const indexCount = i + 1;
      const label = `item_category${indexCount == 1 ? '' : indexCount}`;
      this.categories[label] = cat.name;
    });

    if (orderFormProductsDetails) {
      orderFormProductsDetails
        .filter((o) => o.quantity > 0)
        .forEach((item: any) => {
          const initialItem = {
            item_id: item.id,
            item_name: item.name,
            affiliation: this.affiliation,
            item_brand: product?.brand?.name,
            ...this.categories,
            price: item.price,
            quantity: item.quantity,
          };
          this.orderFormItems.push(initialItem);
        });
    }
    let totalValue = 0;
    let dealerPrice = this.pdpDealerPrice ? this.pdpDealerPrice : 0;
    totalValue = dealerPrice * quantity;
    const gtmTag = {
      event: GoogleTagManagerEvent.ADD_TO_CART,
      ecommerce: {
        currency: this.storageService.getSessionStorageItem('currency'),
        value: !orderFormProductsDetails ? totalValue.toFixed(2) : this.orderFormTotalPrice.toFixed(2),
        items: !orderFormProductsDetails
          ? [
              {
                item_id: product.code,
                item_name: product.name,
                affiliation: this.affiliation,
                item_brand: product?.brand?.name,
                ...this.categories,
                price: dealerPrice,
                quantity,
              },
            ]
          : this.orderFormItems,
      },
    };
    if (gtmTag.ecommerce.items.length > 0) {
      this.gtmService.pushTag({
        ecommerce: null,
        search_term: '',
        results_page: '',
        affiliation: '',
        content_type: '',
        content_id: '',
        content_name: '',
      });
      this.gtmService.pushTag(gtmTag);
    }
  }

  setProductPricingFloatHeight(): void {
    if (!this.isMobileSize && this.float) {
      setTimeout(() => {
        const addToCartEl = document.querySelector('cx-add-to-cart');
        const pdpPrice = document.getElementsByClassName('pdp-price')[0] as HTMLElement;
        if (addToCartEl && pdpPrice) {
          pdpPrice.style.height = addToCartEl.clientHeight.toString() + 'px';
        }
      });
    } else {
      const pdpPrice = document.getElementsByClassName('pdp-price')[0] as HTMLElement;
      if (pdpPrice) {
        pdpPrice.style.height = 'auto';
      }
    }
  }

  get isProductDetailsPage$(): Observable<any> {
    return this.cms.getCurrentPage().pipe(
      filter(Boolean),
      map((currentPage: Page) => currentPage.type === PageType.PRODUCT_PAGE)
    );
  }
  get userCurrent(): string {
    let userCurrent: string;
    this.userCurrent$.pipe(take(1)).subscribe((userId) => (userCurrent = userId));
    return userCurrent;
  }

  get hasInvalidQuantity(): boolean {
    return this.quantity <= 0 && this.addToCartForm.get('quantity').value <= 0;
  }
  get activeLanguage$(): Observable<string> {
    return this.languageService.getActive();
  }

  isBackOrderModalEnabled = () => {
    this.backOrderModalSubscription = this.getBackOrderModalConfig$().subscribe((backOrder) => {
      this.isBackOrderPopupEnabled = backOrder === 'true';
      this.cd.detectChanges();
    });
  };

  getBackOrderModalConfig$(): Observable<string> {
    return this.baseSiteConfigService
      .getBaseSiteConfigValues$(['shimano.backorder.popup.message'])
      .pipe(
        map(
          (configs) =>
            configs &&
            configs
              .filter((config: any) => config.key === 'shimano.backorder.popup.message')
              .map((res: any) => res.value)[0]
        )
      );
  }

  backorderCartCheck(orderFormDetails: OrderFormDetails[]) {
    if (!this.addToCartInprogress) {
      this.addToCartInprogress = true;
      if (this.isBackOrderPopupEnabled) {
        const body = {
          orderEntries: [
            {
              quantity: this.addToCartForm.get('quantity').value,
              product: {
                code: this.productCode,
              },
            },
          ],
        };

        if (orderFormDetails) {
          // build call with multiple
          this.bodyArray = [];
          orderFormDetails.forEach((entry: any) => {
            const jsonBody = {
              quantity: entry.quantity,
              product: {
                code: entry.productCode,
              },
            };
            this.bodyArray.push(jsonBody);
          });
          let strPayload = JSON.stringify(this.bodyArray);
          let payloadHead = '{"orderEntries": ';
          let payloadfoot = ' }';
          let unparsedPayload = payloadHead.concat(strPayload, payloadfoot);

          const parsedPayload = JSON.parse(unparsedPayload);

          const entries = this.orderHistoryService.getInventory(parsedPayload);
          entries.pipe(map((datas) => datas)).subscribe({
            next: (data: any) => {
              if (data['inventoryBackorderList'].length > 0) {
                //add form quantities
                this.backorderCartModal(data, orderFormDetails);
              } else {
                if (orderFormDetails) {
                  this.addToCartOrderForm(orderFormDetails);
                } else {
                  this.addToCart();
                }
              }
            },
            error: (error) => {
              this.addToCartInprogress = false;
              this.showGlobalMessage('cart.genericError', GlobalMessageType.MSG_TYPE_ERROR);
            },
            complete: () => {},
          });
        } else {
          const entries = this.orderHistoryService.getInventory(body);

          entries.pipe(map((datas) => datas)).subscribe({
            next: (data) => {
              if (data.inventoryBackorderList.length > 0) {
                this.backorderCartModal(data, body);
              } else {
                if (orderFormDetails) {
                  this.addToCartOrderForm(orderFormDetails);
                } else {
                  this.addToCart();
                }
              }
            },
            error: (error) => {
              this.addToCartInprogress = false;
              this.showGlobalMessage('cart.genericError', GlobalMessageType.MSG_TYPE_ERROR);
            },
            complete: () => {},
          });
        }
      } else {
        if (orderFormDetails) {
          this.addToCartOrderForm(orderFormDetails);
        } else {
          this.addToCart();
        }
      }
    }
  }

  backorderCartModal(cart: any = null, entries: any): void {
    this.addToCartInprogress = false;
    this.showBackorderCartModal = true;
    this.cd.detectChanges();
    if (!this.addToCartInprogress) {
      this.addToCartInprogress = true;
      this.modalService
        .openDialog(CUSTOM_LAUNCH_CALLER.BACKORDER_CART_MODAL, this.el, this.vcr, {
          backorderEntries: cart,
          formEntries: entries,
          pageType: this.pageType,
        })
        ?.pipe(take(1))
        .subscribe(() => {
          this.addToCartInprogress = false;
        });
    }
  }

  private showGlobalMessage(text: string, messageType: GlobalMessageType, param?: string) {
    this.messageService.add({ key: text, params: { productName: param } }, messageType);
  }

  ngOnDestroy() {
    this.closeModalSubscription$?.unsubscribe();

    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.addToCartSubscription$) {
      this.addToCartSubscription$.unsubscribe();
    }
    if (this.loadAddToCartSubscription$) {
      this.loadAddToCartSubscription$.unsubscribe();
    }
    if (this.orderFormGtmDataLayerSubscription$) {
      this.orderFormGtmDataLayerSubscription$.unsubscribe();
    }
    if (this.cartAddEntrySuccessSubscription$) {
      this.cartAddEntrySuccessSubscription$.unsubscribe();
    }
    if (this.breakpointSubscription$) {
      this.breakpointSubscription$.unsubscribe();
    }
    if (this.gstLabelsSubscription$) {
      this.gstLabelsSubscription$.unsubscribe();
    }
    if (this.orderFormTotalPriceSubscription$) {
      this.orderFormTotalPriceSubscription$.unsubscribe();
    }
    if (this.discontinuedSubscription$) {
      this.discontinuedSubscription$.unsubscribe();
    }
    if (this.backOrderModalSubscription) {
      this.backOrderModalSubscription.unsubscribe();
    }
  }
}
